import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8036c6ae"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["element-loading-background"];
const _hoisted_2 = {
  class: "tabs-warp"
};
const _hoisted_3 = ["element-loading-background"];
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "stack-warp"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "movie-name"
};
const _hoisted_9 = {
  class: "unfold-warp"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "movie-name"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "movie-name"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  class: "movie-name"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "movie-name"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "movie-name"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  class: "stack-warp"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "movie-name"
};
const _hoisted_30 = {
  class: "unfold-warp"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["src"];
const _hoisted_33 = {
  class: "movie-name"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  class: "movie-name"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  class: "movie-name"
};
import ElTabs from '../../../components/ElTabs/index.vue';
import { inject, nextTick, onMounted, onUnmounted } from 'vue';
import { getRecommendPreview } from '@/api/vodPlus';
import { debounce } from '@/utils/tools'; // 运营方案主题数据列表
// const tabList = inject('tabList') as any
// console.log('tabList', tabList);

export default /*#__PURE__*/_defineComponent({
  __name: 'defaultStyleMain',
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const tabList = ref([]);
    const loading = ref(false);
    const imageLists = ref([]);
    const dataLists = ref([]);
    const layoutType = ref('');
    const handleTabClick = debounce(item => {
      // console.log(item);
      dataLists.value = [];
      layoutType.value = item.props.name;
      currentTabData.value = tabList.value.filter(tab => tab.templateName == item.props.name)[0];
      getCategory();
    }, 200);
    const layoutClassObject = {
      movie: 'template-movies',
      series: 'template-series',
      sport: 'template-sports',
      documentary: 'template-documentary',
      kids: 'template-kids',
      discovery: 'template-discovery',
      recommend: 'template-series',
      '4K': 'template-4K'
    };

    const itemClick = item => {
      emit('onCardClick', item);
    };

    watch(() => layoutType.value, val => {}, {
      immediate: true,
      deep: true
    });

    const formateDataList = () => {
      switch (layoutType.value) {
        case 'documentary':
          if (!imageLists.value.length) return [];
          let documentaryArr = [];

          for (let i = 0; i < 5; i++) {
            documentaryArr.push({
              top: { ...imageLists.value[i]
              },
              buttom: { ...imageLists.value[i + 5]
              }
            });
          }

          dataLists.value = documentaryArr;
          break;

        case 'movie':
          if (!imageLists.value.length) return [];
          dataLists.value = imageLists.value;
          break;

        case 'recommend':
          if (!imageLists.value.length) return [];
          const recommendationData = imageLists.value;
          let recommendationArr = [];

          for (let i = 0; i < 4; i++) {
            if (i == 1) {
              recommendationArr.push({
                top: { ...recommendationData[2]
                }
              });
            } else if (i > 1) {
              recommendationArr.push({
                top: { ...recommendationData[i + 1]
                },
                buttom: { ...recommendationData[i + 3]
                }
              });
            } else if (i == 0) {
              recommendationArr.push({
                top: { ...recommendationData[0]
                },
                buttom: { ...recommendationData[1]
                }
              });
            }
          }

          dataLists.value = recommendationArr;
          break;

        case 'series':
          if (!imageLists.value.length) return [];
          const seriesData = imageLists.value;
          let seriesArr = [];

          for (let i = 0; i < 4; i++) {
            if (i == 1) {
              seriesArr.push({
                top: { ...seriesData[2]
                }
              });
            } else if (i > 1) {
              seriesArr.push({
                top: { ...seriesData[i + 1]
                },
                buttom: { ...seriesData[i + 3]
                }
              });
            } else if (i == 0) {
              seriesArr.push({
                top: { ...seriesData[0]
                },
                buttom: { ...seriesData[1]
                }
              });
            }
          }

          dataLists.value = seriesArr;
          break;

        case 'sport':
          if (!imageLists.value.length) return [];
          const sportsData = imageLists.value;
          let sportsArr = [];

          for (let i = 0; i < 4; i++) {
            if (i == 1) {
              sportsArr.push({
                top: { ...sportsData[2]
                }
              });
            } else if (i == 0) {
              sportsArr.push({
                top: { ...sportsData[i]
                },
                buttom: { ...sportsData[i + 1]
                }
              });
            } else {
              sportsArr.push({
                top: { ...sportsData[i + 1]
                },
                middle: { ...sportsData[i + 3]
                },
                buttom: { ...sportsData[i + 5]
                }
              });
            }
          }

          dataLists.value = sportsArr;
          break;

        case 'discovery':
          if (!imageLists.value.length) return [];
          const discoveryData = imageLists.value;
          dataLists.value = discoveryData;
          break;

        case 'kids':
          if (!imageLists.value.length) return [];
          const kidsData = imageLists.value;
          dataLists.value = kidsData;
          break;

        case '4K':
          if (!imageLists.value.length) return [];
          const fourKData = imageLists.value;
          let fourKArr = [];

          for (let i = 0; i < 4; i++) {
            if (i <= 2) {
              fourKArr.push({
                top: { ...fourKData[i]
                }
              });
            } else if (i > 2) {
              fourKArr.push({
                top: { ...fourKData[i]
                },
                buttom: { ...fourKData[i + 1]
                }
              });
            }
          }

          dataLists.value = fourKArr;
          break;

        default:
          break;
      }
    };

    onMounted(() => {
      getData();
    });
    onUnmounted(() => {
      nextTick(() => {
        time.value = 3;
        clearInterval(timer.value);
        timer.value = null;
      });
    });
    const time = ref(0);
    const timer = ref(null);
    const currentTabData = ref(null);
    const viewLoading = ref(false);

    const getData = async () => {
      viewLoading.value = true;

      try {
        const {
          id
        } = currentVodPlusItem.value;
        const res = await getRecommendPreview({
          parent: id
        });

        if (res.status == 200) {
          tabList.value = res.data.data;
          currentTabData.value = tabList.value.length ? tabList.value[0] : '';
          layoutType.value = tabList.value.length ? tabList.value[0].templateName : '';
          getCategory();
        }
      } catch (error) {
        console.log('error-365', error);
      }
    };

    const getCategory = async () => {
      loading.value = true;
      imageLists.value = currentTabData.value.themeItemList;
      formateDataList();
      loading.value = false;
      viewLoading.value = false;
    };

    const currentVodPlusItem = inject('currentVodPlusItem');
    const currentUiStyleOptions = inject('currentUiStyleOptions');
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "default-style-main",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(ElTabs, {
        "tab-value": "templateName",
        "tab-active-name": currentTabData.value && currentTabData.value.template || 1,
        "tab-lists": tabList.value,
        onOnTabClick: _unref(handleTabClick)
      }, null, 8, ["tab-active-name", "tab-lists", "onOnTabClick"])]), _withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [_createElementVNode("div", {
        class: _normalizeClass(["default-padding", layoutClassObject[layoutType.value]])
      }, [layoutType.value == 'movie' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [dataLists.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataLists.value.slice(0, 4), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "stack-item pointer",
          key: index,
          onClick: $event => itemClick(item)
        }, [_createElementVNode("img", {
          src: item.imgUrl,
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)], 8, _hoisted_6);
      }), 128))]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataLists.value.slice(4, 8), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "unfold-item pointer",
          key: index,
          onClick: $event => itemClick(item)
        }, [_createElementVNode("img", {
          src: item.imgUrl,
          alt: ""
        }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)], 8, _hoisted_10);
      }), 128))])])) : _createCommentVNode("", true), !dataLists.value.length && !loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), layoutType.value == 'recommend' || layoutType.value == 'documentary' || layoutType.value == 'series' || layoutType.value == 'sport' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [dataLists.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataLists.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", {
          class: "top pointer",
          onClick: $event => itemClick(item.top)
        }, [_createElementVNode("img", {
          src: item.top.imgUrl,
          alt: ""
        }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, _toDisplayString(item.top.name), 1)], 8, _hoisted_13), item.middle ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "middle pointer",
          onClick: $event => itemClick(item.middle)
        }, [_createElementVNode("img", {
          src: item.middle && item.middle.imgUrl,
          alt: ""
        }, null, 8, _hoisted_17), _createElementVNode("div", _hoisted_18, _toDisplayString(item.middle.name), 1)], 8, _hoisted_16)) : _createCommentVNode("", true), item.buttom ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "buttom pointer",
          onClick: $event => itemClick(item.buttom)
        }, [_createElementVNode("img", {
          src: item.buttom && item.buttom.imgUrl,
          alt: ""
        }, null, 8, _hoisted_20), _createElementVNode("div", _hoisted_21, _toDisplayString(item.buttom.name), 1)], 8, _hoisted_19)) : _createCommentVNode("", true)]);
      }), 128)) : _createCommentVNode("", true), !dataLists.value.length && !loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), layoutType.value == 'discovery' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [dataLists.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataLists.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", {
          class: "top pointer",
          onClick: $event => itemClick(item)
        }, [_createElementVNode("img", {
          src: item.imgUrl,
          alt: ""
        }, null, 8, _hoisted_23), _createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1)], 8, _hoisted_22)]);
      }), 128)) : _createCommentVNode("", true), !dataLists.value.length && !loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), layoutType.value == 'kids' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [dataLists.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataLists.value.slice(0, 2), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "stack-item pointer",
          key: index,
          onClick: $event => itemClick(item)
        }, [_createElementVNode("img", {
          src: item.imgUrl,
          alt: ""
        }, null, 8, _hoisted_28), _createElementVNode("div", _hoisted_29, _toDisplayString(item.name), 1)], 8, _hoisted_27);
      }), 128))]), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataLists.value.slice(2, 7), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "unfold-item pointer",
          key: index,
          onClick: $event => itemClick(item)
        }, [_createElementVNode("img", {
          src: item.imgUrl,
          alt: ""
        }, null, 8, _hoisted_32), _createElementVNode("div", _hoisted_33, _toDisplayString(item.name), 1)], 8, _hoisted_31);
      }), 128))])])) : _createCommentVNode("", true), !dataLists.value.length && !loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "لا توجد بيانات",
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), layoutType.value == '4K' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 4
      }, [dataLists.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(dataLists.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createElementVNode("div", {
          class: "top pointer",
          onClick: $event => itemClick(item.top)
        }, [_createElementVNode("img", {
          src: item.top.imgUrl,
          alt: ""
        }, null, 8, _hoisted_35), _createElementVNode("div", _hoisted_36, _toDisplayString(item.top.name), 1)], 8, _hoisted_34), item.buttom ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "buttom pointer",
          onClick: $event => itemClick(item.buttom)
        }, [_createElementVNode("img", {
          src: item.buttom && item.buttom.imgUrl,
          alt: ""
        }, null, 8, _hoisted_38), _createElementVNode("div", _hoisted_39, _toDisplayString(item.buttom.name), 1)], 8, _hoisted_37)) : _createCommentVNode("", true)]);
      }), 128)) : _createCommentVNode("", true), !dataLists.value.length && !loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "width": "100%"
        },
        "image-size": 50
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 2)], 8, _hoisted_3)), [[_directive_loading, loading.value]])], 8, _hoisted_1)), [[_directive_loading, viewLoading.value]]);
    };
  }

});